export default {
  FOUND: "CUSTOMER_FOUND",
  INVALID: "INVALID_CREDENTIALS",
  NOT_FOUND: "CUSTOMER_NOT_FOUND",
}